import { mirrorX } from "apparatus/draw";
import { P, Segments } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Path } from "paper";
export class Cross {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 10, maxX: 80,
                minY: 5, maxY: 30,
                toAppearance: (f, p) => f({
                    thickness: Math.min(p.y, p.x - 10),
                    length: p.x,
                }),
                fromAppearance: a => P(a.length, a.thickness),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { thickness, length } = appearance;
        const graphic = new Path(Segments([[thickness, length]], [[thickness, thickness]], [[length, thickness]], [[length, -thickness]], [[thickness, -thickness]], [[thickness, -length]]));
        graphic.closePath();
        mirrorX(graphic);
        const shape = graphic.clone();
        // Styling.
        BasicShapes.applyStyle(graphic, appearance);
        return {
            graphic: graphic,
            hitShape: shape,
        };
    }
}
Cross.properties = {
    label: "Cross",
    defaultAppearance: Object.assign({ thickness: 10, length: 50 }, BasicShapes.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.specs,
    ],
};
